<template>
    <about-grin-view/>
</template>
<script>
    import AboutGrinView from "../data-views/AboutGrinView";

    export default {
        name: "AboutGrinRouterView",
        components: {
            AboutGrinView,
        },
    }
</script>
